import moment from "moment";
import ImageInlineView from "components/base/ImageInlineView";
import { getOriginalFileName } from "utils/string";

const IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "svg",
  "avif",
]);

function getFileExtensionFromUrl(url) {
  const normalizedUrl = url.split("?")[0].split("#")[0] || "";
  const extension = normalizedUrl.split(".").pop();
  return extension ? extension.toLowerCase() : "";
}

function isImageUrl(url) {
  return IMAGE_EXTENSIONS.has(getFileExtensionFromUrl(url));
}

function buildThumbnailUrl(url) {
  return url.includes("?") ? `${url}&imageView2/2/w/260` : `${url}?imageView2/2/w/260`;
}

const ImprovementView = ({ improvement }) => {
  const files = improvement?.files || [];
  const imageFiles = files.filter(isImageUrl);
  const otherFiles = files.filter((url) => !isImageUrl(url));
  const images = imageFiles.map((url) => ({
    url,
    thumb: buildThumbnailUrl(url),
  }));

  return (
    <div className="card bg-gray-100 px-5 py-3">
      <div className="opacity-70 text-xs">
        {moment(improvement.updatedAt).format("YYYY-MM-DD HH:mm:ss")}
      </div>
      <div className="mt-1">{improvement.content}</div>
      {images.length > 0 ? (
        <ImageInlineView images={images} />
      ) : null}
      {otherFiles.length > 0 ? (
        <div className="text-xs mt-2">
          {otherFiles.map((url, urlIndex) => (
            <a
              key={urlIndex}
              className="block py-1"
              href={url}
              target="_blank"
              rel="noreferrer"
            >
              📄 {getOriginalFileName(url)}
            </a>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ImprovementView;
